import { ExternalEmployeeResponse } from "@/Common/Api/ExternalCommunications/Dto/Responses/ExternalEmployeeResponse";
import { GridExternalMessageResponse } from "@/Common/Api/ExternalCommunications/Dto/Responses/GridExternalMessageResponse";
import { NameHelper } from "@/Common/Helpers/NameHelper";
import { Guid } from "@/Common/Models/Guid";
import { ExternalMessageSendingStatus } from "./ExternalMessageSendingStatus";

abstract class BaseGridExternalMessage {
    public messageId: string;
    public subject: string;
    public readDate: Date;
    public receivedDate: Date;
    public sendDate: Date;
    public sendStatusLookupId: string;

    public senderInternalEmployeeId: Guid;
    public senderExternalEmployeeFirstName: string;
    public senderExternalEmployeeLastName: string;
    public senderExternalEmployeePrefixLookupId: string;
    public senderExternalEmployeeSiteName: string;
    public senderExternalEmployeeOrganizationName: string;

    public receiverInternalEmployeeId: Guid;
    public receiverExternalEmployeeFirstName: string;
    public receiverExternalEmployeeLastName: string;
    public receiverExternalEmployeePrefixLookupId: string;
    public receiverExternalEmployeeSiteName: string;
    public receiverExternalEmployeeOrganizationName: string;

    public externalPatientId: Guid;
    public externalPatientFirstName: string;
    public externalPatientLastName: string;

    public internalPatientId: Guid;
    public internalPatientFirstName: string;
    public InternalPatientPreferredName: string;
    public internalPatientLastName: string;

    constructor(responseModel: GridExternalMessageResponse) {
        this.messageId = responseModel.MessageId;
        this.subject = responseModel.Subject;
        this.readDate = responseModel.ReadDate;
        this.receivedDate = responseModel.ReceivedDate;
        this.sendDate = responseModel.SendDate;
        this.sendStatusLookupId = responseModel.SendStatusLookupId;

        this.senderInternalEmployeeId = responseModel.SenderInternalEmployeeId;
        this.senderExternalEmployeeFirstName = responseModel.SenderExternalEmployeeFirstName;
        this.senderExternalEmployeeLastName = responseModel.SenderExternalEmployeeLastName;
        this.senderExternalEmployeePrefixLookupId = responseModel.SenderExternalEmployeePrefixLookupId;
        this.senderExternalEmployeeSiteName = responseModel.SenderExternalEmployeeSiteName;
        this.senderExternalEmployeeOrganizationName = responseModel.SenderExternalEmployeeOrganizationName;

        this.receiverInternalEmployeeId = responseModel.ReceiverInternalEmployeeId;
        this.receiverExternalEmployeeFirstName = responseModel.ReceiverExternalEmployeeFirstName;
        this.receiverExternalEmployeeLastName = responseModel.ReceiverExternalEmployeeLastName;
        this.receiverExternalEmployeePrefixLookupId = responseModel.ReceiverExternalEmployeePrefixLookupId;
        this.receiverExternalEmployeeSiteName = responseModel.ReceiverExternalEmployeeSiteName;
        this.receiverExternalEmployeeOrganizationName = responseModel.ReceiverExternalEmployeeOrganizationName;

        this.externalPatientId = responseModel.ExternalPatientId;
        this.externalPatientFirstName = responseModel.ExternalPatientFirstName;
        this.externalPatientLastName = responseModel.ExternalPatientLastName;

        this.internalPatientId = responseModel.InternalPatientId;
        this.internalPatientFirstName = responseModel.InternalPatientFirstName;
        this.InternalPatientPreferredName = responseModel.InternalPatientPreferredName;
        this.internalPatientLastName = responseModel.InternalPatientLastName;
    }

    public get isRead(): boolean {
        return !!this.readDate;
    }

    public get senderDisplayName(): string {
        if (this.senderInternalEmployeeId)
            return this.getInternalEmployeeDisplayName(this.senderInternalEmployeeId);

        return ExternalEmployeeResponse.buildDisplayName(
            this.senderExternalEmployeeFirstName,
            this.senderExternalEmployeeLastName,
            this.senderExternalEmployeePrefixLookupId,
            this.senderExternalEmployeeOrganizationName,
            this.senderExternalEmployeeSiteName
        );
    }

    public get receiverDisplayName(): string {
        if (this.receiverInternalEmployeeId)
            return this.getInternalEmployeeDisplayName(this.receiverInternalEmployeeId);

        return ExternalEmployeeResponse.buildDisplayName(
            this.receiverExternalEmployeeFirstName,
            this.receiverExternalEmployeeLastName,
            this.receiverExternalEmployeePrefixLookupId,
            this.receiverExternalEmployeeOrganizationName,
            this.receiverExternalEmployeeSiteName
        );
    }

    public get patientDisplayName(): string {
        if (!this.internalPatientId && !this.externalPatientId)
            return "";

        if (this.internalPatientId)
            return NameHelper.formatFullName(this.internalPatientFirstName, this.internalPatientLastName, this.InternalPatientPreferredName);

        return NameHelper.formatFullName(this.externalPatientFirstName, this.externalPatientLastName, null);
    }

    public get isFailedSend(): boolean {
        return ExternalMessageSendingStatus.failed.LookupID === this.sendStatusLookupId;
    }

    private getInternalEmployeeDisplayName(contactFacetId: Guid): string {
        let employee = cacheStore.GetEmployeeByContactFacetId(contactFacetId);
        let licenceNumber = employee.FirstLicenceNumber ? `(${employee.FirstLicenceNumber})` : "";
        return `${employee.LastName}, ${employee.FirstName} ${licenceNumber}`;
    }
}

class ExternalMessageInbox extends BaseGridExternalMessage {

}

class ExternalMessageOutbox extends BaseGridExternalMessage {

}

class PatientHistoryMessage extends BaseGridExternalMessage {

}

export { BaseGridExternalMessage, ExternalMessageInbox, ExternalMessageOutbox, PatientHistoryMessage };
